(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1248],{

/***/ 42159:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/courses/[courseId]",
      function () {
        return __webpack_require__(32350);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 32350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ CourseDetailPage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(47568);
/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var config_env__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(36514);
/* harmony import */ var common_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22467);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var components_CourseDetails__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10821);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88767);
/* harmony import */ var service_course__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11038);
/* harmony import */ var store_global__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8405);
/* harmony import */ var _CourseDetailPage_module_scss__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(32684);
/* harmony import */ var _CourseDetailPage_module_scss__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_CourseDetailPage_module_scss__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var components_common_Icon__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(37975);
/* harmony import */ var common_utils_course__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5439);
/* harmony import */ var components_CoursePageSection__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(3920);















var __N_SSP = true;
function CourseDetailPage(props) {
    var courseId = props.courseId;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)((0,common_utils__WEBPACK_IMPORTED_MODULE_3__/* .parseJSON */ .Rx)(props.course)), courseInfo = ref[0], setCourseInfo = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(function() {
        if (!courseInfo || !courseInfo.lectures) return;
        return courseInfo.lectures[0];
    }), currentLecture = ref1[0], setCurrentLecture = ref1[1];
    var isAuthInit = (0,store_global__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(state) {
        return state.isAuthInit;
    });
    var ref2 = (0,react_query__WEBPACK_IMPORTED_MODULE_6__.useQuery)([
        "getCourseDetail",
        courseId === null || courseId === void 0 ? void 0 : courseId.toString()
    ], (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (courseId) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return", Promise.reject());
                case 2:
                    return _ctx.abrupt("return", (0,service_course__WEBPACK_IMPORTED_MODULE_7__/* .getCourseDetail */ .Sp)(courseId));
                case 3:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), {
        enabled: isAuthInit && !!courseId,
        retry: false,
        onSuccess: function(data) {
            var course = data === null || data === void 0 ? void 0 : data.data;
            setCourseInfo(course);
            if (!currentLecture) {
                setCurrentLecture(course.lectures[0]);
            } else {
                var lecture = course.lectures.find(function(lecture) {
                    return lecture.id === (currentLecture === null || currentLecture === void 0 ? void 0 : currentLecture.id);
                });
                setCurrentLecture(lecture);
            }
        },
        refetchOnWindowFocus: false
    }), isError = ref2.isError, isLoading = ref2.isLoading, isFetching = ref2.isFetching, refetch = ref2.refetch;
    var ogpData = (0,common_utils_course__WEBPACK_IMPORTED_MODULE_10__/* .ogpDataOfCourse */ .x1)(courseInfo);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("title", {
                        children: ogpData.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        name: "description",
                        content: ogpData.description
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        property: "og:type",
                        content: "course"
                    }, "ogtype"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        property: "og:title",
                        content: ogpData.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        property: "og:description",
                        content: ogpData.description
                    }),
                    ogpData.imageUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        property: "og:image",
                        content: ogpData.imageUrl || ""
                    }, "ogimage"),
                    ((courseInfo === null || courseInfo === void 0 ? void 0 : courseInfo.benefits) || []).length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        name: "keywords",
                        content: ((courseInfo === null || courseInfo === void 0 ? void 0 : courseInfo.benefits) || []).join(", ")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        property: "twitter:url",
                        content: "".concat(config_env__WEBPACK_IMPORTED_MODULE_13__/* .SITE_BASE_URL */ .B, "/courses/").concat(courseId)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        name: "twitter:title",
                        content: ogpData.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        name: "twitter:description",
                        content: ogpData.description
                    }),
                    ogpData.imageUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
                        name: "twitter:image",
                        content: ogpData.imageUrl || ""
                    }, "twimage"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
                        rel: "canonical",
                        href: "".concat(config_env__WEBPACK_IMPORTED_MODULE_13__/* .SITE_BASE_URL */ .B, "/courses/").concat(courseId)
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_CoursePageSection__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                children: isError && !isLoading && !isFetching ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: (_CourseDetailPage_module_scss__WEBPACK_IMPORTED_MODULE_14___default().emptyWrapper),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_Icon__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP, {
                            name: "empty",
                            width: 96,
                            height: 96
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: (_CourseDetailPage_module_scss__WEBPACK_IMPORTED_MODULE_14___default().emptyText),
                            children: "このコースは存在しません"
                        })
                    ]
                }) : courseInfo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_CourseDetails__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    courseInfo: courseInfo,
                    refetchCourse: refetch,
                    currentLecture: currentLecture,
                    setCurrentLecture: setCurrentLecture
                })
            })
        ]
    });
};


/***/ }),

/***/ 32684:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"emptyWrapper":"CourseDetailPage_emptyWrapper__oGyY6","emptyText":"CourseDetailPage_emptyText__nsZpN"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6007,6310,9122,8369,4850,6720,1038,4081,3920,9774,2888,179], function() { return __webpack_exec__(42159); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);